export const SALARY_SETTINGS_QUERY_KEY = 'salarySettingsQueryKey'
export const LAST_SALARY_SETTINGS_QUERY_KEY = 'lastSalarySettingsQueryKey'
export const COUNT_SALARY_SETTINGS_QUERY_KEY = 'countSalarySettingsQueryKey'
export const SALARY_RATE_SETTINGS_QUERY_KEY = 'salaryRateSettingsQueryKey'
